// source: types/ui.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var types_time_data_pb = require('../types/time_data_pb.js');
goog.object.extend(proto, types_time_data_pb);
goog.exportSymbol('proto.types.AdvancePaymentWidgetData', null, global);
goog.exportSymbol('proto.types.AdvancePaymentWidgetData.ChartData', null, global);
goog.exportSymbol('proto.types.CurrentMonthWidgetData', null, global);
goog.exportSymbol('proto.types.CurrentMonthWidgetData.Delta', null, global);
goog.exportSymbol('proto.types.CurrentMonthWidgetData.Delta.Tendency', null, global);
goog.exportSymbol('proto.types.CurrentMonthWidgetData.Value', null, global);
goog.exportSymbol('proto.types.SpaceComparisonWidgetData', null, global);
goog.exportSymbol('proto.types.SpaceComparisonWidgetData.ComparisonResult', null, global);
goog.exportSymbol('proto.types.SpaceComparisonWidgetData.ComparisonValue', null, global);
goog.exportSymbol('proto.types.SpaceComparisonWidgetData.TimePeriodTab', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.CurrentMonthWidgetData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.types.CurrentMonthWidgetData.repeatedFields_, null);
};
goog.inherits(proto.types.CurrentMonthWidgetData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.CurrentMonthWidgetData.displayName = 'proto.types.CurrentMonthWidgetData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.CurrentMonthWidgetData.Value = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.CurrentMonthWidgetData.Value, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.CurrentMonthWidgetData.Value.displayName = 'proto.types.CurrentMonthWidgetData.Value';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.CurrentMonthWidgetData.Delta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.CurrentMonthWidgetData.Delta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.CurrentMonthWidgetData.Delta.displayName = 'proto.types.CurrentMonthWidgetData.Delta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.AdvancePaymentWidgetData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.AdvancePaymentWidgetData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.AdvancePaymentWidgetData.displayName = 'proto.types.AdvancePaymentWidgetData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.AdvancePaymentWidgetData.ChartData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.types.AdvancePaymentWidgetData.ChartData.repeatedFields_, null);
};
goog.inherits(proto.types.AdvancePaymentWidgetData.ChartData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.AdvancePaymentWidgetData.ChartData.displayName = 'proto.types.AdvancePaymentWidgetData.ChartData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.SpaceComparisonWidgetData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.types.SpaceComparisonWidgetData.repeatedFields_, null);
};
goog.inherits(proto.types.SpaceComparisonWidgetData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.SpaceComparisonWidgetData.displayName = 'proto.types.SpaceComparisonWidgetData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.SpaceComparisonWidgetData.ComparisonValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.SpaceComparisonWidgetData.ComparisonValue.displayName = 'proto.types.SpaceComparisonWidgetData.ComparisonValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.SpaceComparisonWidgetData.TimePeriodTab, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.SpaceComparisonWidgetData.TimePeriodTab.displayName = 'proto.types.SpaceComparisonWidgetData.TimePeriodTab';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.types.CurrentMonthWidgetData.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.CurrentMonthWidgetData.prototype.toObject = function(opt_includeInstance) {
  return proto.types.CurrentMonthWidgetData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.CurrentMonthWidgetData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.CurrentMonthWidgetData.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: jspb.Message.getFieldWithDefault(msg, 1, ""),
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    proto.types.CurrentMonthWidgetData.Value.toObject, includeInstance),
    delta: (f = msg.getDelta()) && proto.types.CurrentMonthWidgetData.Delta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.CurrentMonthWidgetData}
 */
proto.types.CurrentMonthWidgetData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.CurrentMonthWidgetData;
  return proto.types.CurrentMonthWidgetData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.CurrentMonthWidgetData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.CurrentMonthWidgetData}
 */
proto.types.CurrentMonthWidgetData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInfo(value);
      break;
    case 2:
      var value = new proto.types.CurrentMonthWidgetData.Value;
      reader.readMessage(value,proto.types.CurrentMonthWidgetData.Value.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    case 3:
      var value = new proto.types.CurrentMonthWidgetData.Delta;
      reader.readMessage(value,proto.types.CurrentMonthWidgetData.Delta.deserializeBinaryFromReader);
      msg.setDelta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.CurrentMonthWidgetData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.CurrentMonthWidgetData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.CurrentMonthWidgetData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.CurrentMonthWidgetData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.types.CurrentMonthWidgetData.Value.serializeBinaryToWriter
    );
  }
  f = message.getDelta();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.types.CurrentMonthWidgetData.Delta.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.CurrentMonthWidgetData.Value.prototype.toObject = function(opt_includeInstance) {
  return proto.types.CurrentMonthWidgetData.Value.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.CurrentMonthWidgetData.Value} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.CurrentMonthWidgetData.Value.toObject = function(includeInstance, msg) {
  var f, obj = {
    label: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    valueFormatted: jspb.Message.getFieldWithDefault(msg, 5, ""),
    unit: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tooltip: jspb.Message.getFieldWithDefault(msg, 4, ""),
    dataCoverageAlert: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.CurrentMonthWidgetData.Value}
 */
proto.types.CurrentMonthWidgetData.Value.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.CurrentMonthWidgetData.Value;
  return proto.types.CurrentMonthWidgetData.Value.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.CurrentMonthWidgetData.Value} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.CurrentMonthWidgetData.Value}
 */
proto.types.CurrentMonthWidgetData.Value.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setValueFormatted(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTooltip(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDataCoverageAlert(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.CurrentMonthWidgetData.Value.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.CurrentMonthWidgetData.Value.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.CurrentMonthWidgetData.Value} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.CurrentMonthWidgetData.Value.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getValueFormatted();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDataCoverageAlert();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.types.CurrentMonthWidgetData.Value.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.CurrentMonthWidgetData.Value} returns this
 */
proto.types.CurrentMonthWidgetData.Value.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.types.CurrentMonthWidgetData.Value.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.types.CurrentMonthWidgetData.Value} returns this
 */
proto.types.CurrentMonthWidgetData.Value.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string value_formatted = 5;
 * @return {string}
 */
proto.types.CurrentMonthWidgetData.Value.prototype.getValueFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.CurrentMonthWidgetData.Value} returns this
 */
proto.types.CurrentMonthWidgetData.Value.prototype.setValueFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string unit = 3;
 * @return {string}
 */
proto.types.CurrentMonthWidgetData.Value.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.CurrentMonthWidgetData.Value} returns this
 */
proto.types.CurrentMonthWidgetData.Value.prototype.setUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string tooltip = 4;
 * @return {string}
 */
proto.types.CurrentMonthWidgetData.Value.prototype.getTooltip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.CurrentMonthWidgetData.Value} returns this
 */
proto.types.CurrentMonthWidgetData.Value.prototype.setTooltip = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.types.CurrentMonthWidgetData.Value} returns this
 */
proto.types.CurrentMonthWidgetData.Value.prototype.clearTooltip = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.CurrentMonthWidgetData.Value.prototype.hasTooltip = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool data_coverage_alert = 6;
 * @return {boolean}
 */
proto.types.CurrentMonthWidgetData.Value.prototype.getDataCoverageAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.types.CurrentMonthWidgetData.Value} returns this
 */
proto.types.CurrentMonthWidgetData.Value.prototype.setDataCoverageAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.toObject = function(opt_includeInstance) {
  return proto.types.CurrentMonthWidgetData.Delta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.CurrentMonthWidgetData.Delta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.CurrentMonthWidgetData.Delta.toObject = function(includeInstance, msg) {
  var f, obj = {
    icon: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    unit: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tendency: jspb.Message.getFieldWithDefault(msg, 4, 0),
    tooltip: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.CurrentMonthWidgetData.Delta}
 */
proto.types.CurrentMonthWidgetData.Delta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.CurrentMonthWidgetData.Delta;
  return proto.types.CurrentMonthWidgetData.Delta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.CurrentMonthWidgetData.Delta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.CurrentMonthWidgetData.Delta}
 */
proto.types.CurrentMonthWidgetData.Delta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnit(value);
      break;
    case 4:
      var value = /** @type {!proto.types.CurrentMonthWidgetData.Delta.Tendency} */ (reader.readEnum());
      msg.setTendency(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTooltip(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.CurrentMonthWidgetData.Delta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.CurrentMonthWidgetData.Delta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.CurrentMonthWidgetData.Delta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTendency();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.types.CurrentMonthWidgetData.Delta.Tendency = {
  GOOD: 0,
  BAD: 1
};

/**
 * optional string icon = 1;
 * @return {string}
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.CurrentMonthWidgetData.Delta} returns this
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.types.CurrentMonthWidgetData.Delta} returns this
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string unit = 3;
 * @return {string}
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.CurrentMonthWidgetData.Delta} returns this
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.setUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Tendency tendency = 4;
 * @return {!proto.types.CurrentMonthWidgetData.Delta.Tendency}
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.getTendency = function() {
  return /** @type {!proto.types.CurrentMonthWidgetData.Delta.Tendency} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.types.CurrentMonthWidgetData.Delta.Tendency} value
 * @return {!proto.types.CurrentMonthWidgetData.Delta} returns this
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.setTendency = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string tooltip = 5;
 * @return {string}
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.getTooltip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.CurrentMonthWidgetData.Delta} returns this
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.setTooltip = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.types.CurrentMonthWidgetData.Delta} returns this
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.clearTooltip = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.CurrentMonthWidgetData.Delta.prototype.hasTooltip = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string info = 1;
 * @return {string}
 */
proto.types.CurrentMonthWidgetData.prototype.getInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.CurrentMonthWidgetData} returns this
 */
proto.types.CurrentMonthWidgetData.prototype.setInfo = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.types.CurrentMonthWidgetData} returns this
 */
proto.types.CurrentMonthWidgetData.prototype.clearInfo = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.CurrentMonthWidgetData.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Value values = 2;
 * @return {!Array<!proto.types.CurrentMonthWidgetData.Value>}
 */
proto.types.CurrentMonthWidgetData.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.types.CurrentMonthWidgetData.Value>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.types.CurrentMonthWidgetData.Value, 2));
};


/**
 * @param {!Array<!proto.types.CurrentMonthWidgetData.Value>} value
 * @return {!proto.types.CurrentMonthWidgetData} returns this
*/
proto.types.CurrentMonthWidgetData.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.types.CurrentMonthWidgetData.Value=} opt_value
 * @param {number=} opt_index
 * @return {!proto.types.CurrentMonthWidgetData.Value}
 */
proto.types.CurrentMonthWidgetData.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.types.CurrentMonthWidgetData.Value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.types.CurrentMonthWidgetData} returns this
 */
proto.types.CurrentMonthWidgetData.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional Delta delta = 3;
 * @return {?proto.types.CurrentMonthWidgetData.Delta}
 */
proto.types.CurrentMonthWidgetData.prototype.getDelta = function() {
  return /** @type{?proto.types.CurrentMonthWidgetData.Delta} */ (
    jspb.Message.getWrapperField(this, proto.types.CurrentMonthWidgetData.Delta, 3));
};


/**
 * @param {?proto.types.CurrentMonthWidgetData.Delta|undefined} value
 * @return {!proto.types.CurrentMonthWidgetData} returns this
*/
proto.types.CurrentMonthWidgetData.prototype.setDelta = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.types.CurrentMonthWidgetData} returns this
 */
proto.types.CurrentMonthWidgetData.prototype.clearDelta = function() {
  return this.setDelta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.CurrentMonthWidgetData.prototype.hasDelta = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.AdvancePaymentWidgetData.prototype.toObject = function(opt_includeInstance) {
  return proto.types.AdvancePaymentWidgetData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.AdvancePaymentWidgetData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.AdvancePaymentWidgetData.toObject = function(includeInstance, msg) {
  var f, obj = {
    currentMonthlyAdvancePayment: jspb.Message.getFieldWithDefault(msg, 1, ""),
    currentMonthLabel: jspb.Message.getFieldWithDefault(msg, 2, ""),
    costPrediction: jspb.Message.getFieldWithDefault(msg, 3, ""),
    unit: jspb.Message.getFieldWithDefault(msg, 4, ""),
    infoText: jspb.Message.getFieldWithDefault(msg, 5, ""),
    sumOverPeriod: jspb.Message.getFieldWithDefault(msg, 6, ""),
    chartData: (f = msg.getChartData()) && proto.types.AdvancePaymentWidgetData.ChartData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.AdvancePaymentWidgetData}
 */
proto.types.AdvancePaymentWidgetData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.AdvancePaymentWidgetData;
  return proto.types.AdvancePaymentWidgetData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.AdvancePaymentWidgetData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.AdvancePaymentWidgetData}
 */
proto.types.AdvancePaymentWidgetData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentMonthlyAdvancePayment(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentMonthLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCostPrediction(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInfoText(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSumOverPeriod(value);
      break;
    case 7:
      var value = new proto.types.AdvancePaymentWidgetData.ChartData;
      reader.readMessage(value,proto.types.AdvancePaymentWidgetData.ChartData.deserializeBinaryFromReader);
      msg.setChartData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.AdvancePaymentWidgetData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.AdvancePaymentWidgetData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.AdvancePaymentWidgetData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.AdvancePaymentWidgetData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentMonthlyAdvancePayment();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrentMonthLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCostPrediction();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInfoText();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSumOverPeriod();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getChartData();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.types.AdvancePaymentWidgetData.ChartData.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.types.AdvancePaymentWidgetData.ChartData.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.toObject = function(opt_includeInstance) {
  return proto.types.AdvancePaymentWidgetData.ChartData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.AdvancePaymentWidgetData.ChartData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.AdvancePaymentWidgetData.ChartData.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 1)) == null ? undefined : f,
    labelsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    barColorsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData}
 */
proto.types.AdvancePaymentWidgetData.ChartData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.AdvancePaymentWidgetData.ChartData;
  return proto.types.AdvancePaymentWidgetData.ChartData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.AdvancePaymentWidgetData.ChartData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData}
 */
proto.types.AdvancePaymentWidgetData.ChartData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabels(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addBarColors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.AdvancePaymentWidgetData.ChartData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.AdvancePaymentWidgetData.ChartData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.AdvancePaymentWidgetData.ChartData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedDouble(
      1,
      f
    );
  }
  f = message.getLabelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getBarColorsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * repeated double values = 1;
 * @return {!Array<number>}
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData} returns this
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData} returns this
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData} returns this
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * repeated string labels = 2;
 * @return {!Array<string>}
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.getLabelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData} returns this
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.setLabelsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData} returns this
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.addLabels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData} returns this
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.clearLabelsList = function() {
  return this.setLabelsList([]);
};


/**
 * repeated string bar_colors = 3;
 * @return {!Array<string>}
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.getBarColorsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData} returns this
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.setBarColorsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData} returns this
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.addBarColors = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.types.AdvancePaymentWidgetData.ChartData} returns this
 */
proto.types.AdvancePaymentWidgetData.ChartData.prototype.clearBarColorsList = function() {
  return this.setBarColorsList([]);
};


/**
 * optional string current_monthly_advance_payment = 1;
 * @return {string}
 */
proto.types.AdvancePaymentWidgetData.prototype.getCurrentMonthlyAdvancePayment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.AdvancePaymentWidgetData} returns this
 */
proto.types.AdvancePaymentWidgetData.prototype.setCurrentMonthlyAdvancePayment = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string current_month_label = 2;
 * @return {string}
 */
proto.types.AdvancePaymentWidgetData.prototype.getCurrentMonthLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.AdvancePaymentWidgetData} returns this
 */
proto.types.AdvancePaymentWidgetData.prototype.setCurrentMonthLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string cost_prediction = 3;
 * @return {string}
 */
proto.types.AdvancePaymentWidgetData.prototype.getCostPrediction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.AdvancePaymentWidgetData} returns this
 */
proto.types.AdvancePaymentWidgetData.prototype.setCostPrediction = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string unit = 4;
 * @return {string}
 */
proto.types.AdvancePaymentWidgetData.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.AdvancePaymentWidgetData} returns this
 */
proto.types.AdvancePaymentWidgetData.prototype.setUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string info_text = 5;
 * @return {string}
 */
proto.types.AdvancePaymentWidgetData.prototype.getInfoText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.AdvancePaymentWidgetData} returns this
 */
proto.types.AdvancePaymentWidgetData.prototype.setInfoText = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string sum_over_period = 6;
 * @return {string}
 */
proto.types.AdvancePaymentWidgetData.prototype.getSumOverPeriod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.AdvancePaymentWidgetData} returns this
 */
proto.types.AdvancePaymentWidgetData.prototype.setSumOverPeriod = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional ChartData chart_data = 7;
 * @return {?proto.types.AdvancePaymentWidgetData.ChartData}
 */
proto.types.AdvancePaymentWidgetData.prototype.getChartData = function() {
  return /** @type{?proto.types.AdvancePaymentWidgetData.ChartData} */ (
    jspb.Message.getWrapperField(this, proto.types.AdvancePaymentWidgetData.ChartData, 7));
};


/**
 * @param {?proto.types.AdvancePaymentWidgetData.ChartData|undefined} value
 * @return {!proto.types.AdvancePaymentWidgetData} returns this
*/
proto.types.AdvancePaymentWidgetData.prototype.setChartData = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.types.AdvancePaymentWidgetData} returns this
 */
proto.types.AdvancePaymentWidgetData.prototype.clearChartData = function() {
  return this.setChartData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.AdvancePaymentWidgetData.prototype.hasChartData = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.types.SpaceComparisonWidgetData.repeatedFields_ = [2,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.SpaceComparisonWidgetData.prototype.toObject = function(opt_includeInstance) {
  return proto.types.SpaceComparisonWidgetData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.SpaceComparisonWidgetData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.SpaceComparisonWidgetData.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 1, ""),
    comparisonValuesList: jspb.Message.toObjectList(msg.getComparisonValuesList(),
    proto.types.SpaceComparisonWidgetData.ComparisonValue.toObject, includeInstance),
    comparisonResult: jspb.Message.getFieldWithDefault(msg, 3, 0),
    timePeriodTabsList: jspb.Message.toObjectList(msg.getTimePeriodTabsList(),
    proto.types.SpaceComparisonWidgetData.TimePeriodTab.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.SpaceComparisonWidgetData}
 */
proto.types.SpaceComparisonWidgetData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.SpaceComparisonWidgetData;
  return proto.types.SpaceComparisonWidgetData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.SpaceComparisonWidgetData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.SpaceComparisonWidgetData}
 */
proto.types.SpaceComparisonWidgetData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = new proto.types.SpaceComparisonWidgetData.ComparisonValue;
      reader.readMessage(value,proto.types.SpaceComparisonWidgetData.ComparisonValue.deserializeBinaryFromReader);
      msg.addComparisonValues(value);
      break;
    case 3:
      var value = /** @type {!proto.types.SpaceComparisonWidgetData.ComparisonResult} */ (reader.readEnum());
      msg.setComparisonResult(value);
      break;
    case 4:
      var value = new proto.types.SpaceComparisonWidgetData.TimePeriodTab;
      reader.readMessage(value,proto.types.SpaceComparisonWidgetData.TimePeriodTab.deserializeBinaryFromReader);
      msg.addTimePeriodTabs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.SpaceComparisonWidgetData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.SpaceComparisonWidgetData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.SpaceComparisonWidgetData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.SpaceComparisonWidgetData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getComparisonValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.types.SpaceComparisonWidgetData.ComparisonValue.serializeBinaryToWriter
    );
  }
  f = message.getComparisonResult();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTimePeriodTabsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.types.SpaceComparisonWidgetData.TimePeriodTab.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.types.SpaceComparisonWidgetData.ComparisonResult = {
  HIGHER: 0,
  LOWER: 1
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.toObject = function(opt_includeInstance) {
  return proto.types.SpaceComparisonWidgetData.ComparisonValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.SpaceComparisonWidgetData.ComparisonValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    label: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    valueFormatted: jspb.Message.getFieldWithDefault(msg, 3, ""),
    unit: jspb.Message.getFieldWithDefault(msg, 4, ""),
    color: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.SpaceComparisonWidgetData.ComparisonValue}
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.SpaceComparisonWidgetData.ComparisonValue;
  return proto.types.SpaceComparisonWidgetData.ComparisonValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.SpaceComparisonWidgetData.ComparisonValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.SpaceComparisonWidgetData.ComparisonValue}
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValueFormatted(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.SpaceComparisonWidgetData.ComparisonValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.SpaceComparisonWidgetData.ComparisonValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getValueFormatted();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.SpaceComparisonWidgetData.ComparisonValue} returns this
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.types.SpaceComparisonWidgetData.ComparisonValue} returns this
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string value_formatted = 3;
 * @return {string}
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.getValueFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.SpaceComparisonWidgetData.ComparisonValue} returns this
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.setValueFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string unit = 4;
 * @return {string}
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.SpaceComparisonWidgetData.ComparisonValue} returns this
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.setUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string color = 5;
 * @return {string}
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.SpaceComparisonWidgetData.ComparisonValue} returns this
 */
proto.types.SpaceComparisonWidgetData.ComparisonValue.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab.prototype.toObject = function(opt_includeInstance) {
  return proto.types.SpaceComparisonWidgetData.TimePeriodTab.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.SpaceComparisonWidgetData.TimePeriodTab} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab.toObject = function(includeInstance, msg) {
  var f, obj = {
    label: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.SpaceComparisonWidgetData.TimePeriodTab}
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.SpaceComparisonWidgetData.TimePeriodTab;
  return proto.types.SpaceComparisonWidgetData.TimePeriodTab.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.SpaceComparisonWidgetData.TimePeriodTab} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.SpaceComparisonWidgetData.TimePeriodTab}
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {!proto.types.TimePeriod} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.SpaceComparisonWidgetData.TimePeriodTab.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.SpaceComparisonWidgetData.TimePeriodTab} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.SpaceComparisonWidgetData.TimePeriodTab} returns this
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TimePeriod value = 2;
 * @return {!proto.types.TimePeriod}
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab.prototype.getValue = function() {
  return /** @type {!proto.types.TimePeriod} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.types.TimePeriod} value
 * @return {!proto.types.SpaceComparisonWidgetData.TimePeriodTab} returns this
 */
proto.types.SpaceComparisonWidgetData.TimePeriodTab.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.types.SpaceComparisonWidgetData.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.SpaceComparisonWidgetData} returns this
 */
proto.types.SpaceComparisonWidgetData.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ComparisonValue comparison_values = 2;
 * @return {!Array<!proto.types.SpaceComparisonWidgetData.ComparisonValue>}
 */
proto.types.SpaceComparisonWidgetData.prototype.getComparisonValuesList = function() {
  return /** @type{!Array<!proto.types.SpaceComparisonWidgetData.ComparisonValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.types.SpaceComparisonWidgetData.ComparisonValue, 2));
};


/**
 * @param {!Array<!proto.types.SpaceComparisonWidgetData.ComparisonValue>} value
 * @return {!proto.types.SpaceComparisonWidgetData} returns this
*/
proto.types.SpaceComparisonWidgetData.prototype.setComparisonValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.types.SpaceComparisonWidgetData.ComparisonValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.types.SpaceComparisonWidgetData.ComparisonValue}
 */
proto.types.SpaceComparisonWidgetData.prototype.addComparisonValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.types.SpaceComparisonWidgetData.ComparisonValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.types.SpaceComparisonWidgetData} returns this
 */
proto.types.SpaceComparisonWidgetData.prototype.clearComparisonValuesList = function() {
  return this.setComparisonValuesList([]);
};


/**
 * optional ComparisonResult comparison_result = 3;
 * @return {!proto.types.SpaceComparisonWidgetData.ComparisonResult}
 */
proto.types.SpaceComparisonWidgetData.prototype.getComparisonResult = function() {
  return /** @type {!proto.types.SpaceComparisonWidgetData.ComparisonResult} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.types.SpaceComparisonWidgetData.ComparisonResult} value
 * @return {!proto.types.SpaceComparisonWidgetData} returns this
 */
proto.types.SpaceComparisonWidgetData.prototype.setComparisonResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated TimePeriodTab time_period_tabs = 4;
 * @return {!Array<!proto.types.SpaceComparisonWidgetData.TimePeriodTab>}
 */
proto.types.SpaceComparisonWidgetData.prototype.getTimePeriodTabsList = function() {
  return /** @type{!Array<!proto.types.SpaceComparisonWidgetData.TimePeriodTab>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.types.SpaceComparisonWidgetData.TimePeriodTab, 4));
};


/**
 * @param {!Array<!proto.types.SpaceComparisonWidgetData.TimePeriodTab>} value
 * @return {!proto.types.SpaceComparisonWidgetData} returns this
*/
proto.types.SpaceComparisonWidgetData.prototype.setTimePeriodTabsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.types.SpaceComparisonWidgetData.TimePeriodTab=} opt_value
 * @param {number=} opt_index
 * @return {!proto.types.SpaceComparisonWidgetData.TimePeriodTab}
 */
proto.types.SpaceComparisonWidgetData.prototype.addTimePeriodTabs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.types.SpaceComparisonWidgetData.TimePeriodTab, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.types.SpaceComparisonWidgetData} returns this
 */
proto.types.SpaceComparisonWidgetData.prototype.clearTimePeriodTabsList = function() {
  return this.setTimePeriodTabsList([]);
};


goog.object.extend(exports, proto.types);
